var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jet-authentication-card",
    {
      scopedSlots: _vm._u([
        {
          key: "logo",
          fn: function () {
            return [_c("jet-authentication-card-logo")]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "mb-4 text-sm text-gray-600" }, [
        _vm._v(
          "\n        This is a secure area of the application. Please confirm your\n        password before continuing.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("jet-validation-errors", { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("jet-label", {
                attrs: { for: "password", value: "Password" },
              }),
              _vm._v(" "),
              _c("jet-input", {
                staticClass: "mt-1 block w-full",
                attrs: {
                  id: "password",
                  type: "password",
                  required: "",
                  autocomplete: "current-password",
                  autofocus: "",
                },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-end mt-4" },
            [
              _c(
                "jet-button",
                {
                  staticClass: "ml-4",
                  class: { "opacity-25": _vm.form.processing },
                  attrs: { disabled: _vm.form.processing },
                },
                [_vm._v("\n                Confirm\n            ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }